module.exports = __webpack_public_path__ + "img/iconDownloadMapGreen.9144ac66.svg";